'use client'

import { useCallback, useState } from 'react'
import * as Sentry from '@sentry/nextjs'
import { useAuth } from '@/hooks/useAuth'
import { SignUpModal } from './SignUpModal'

interface RealAccountCommandGateOptions {
  projectId?: string
  returnPath?: string
}

export function useRealAccountCommandGate(options?: RealAccountCommandGateOptions) {
  const { isAnonymous } = useAuth()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const guardAction = useCallback(
    (actionName?: string) => {
      if (!isAnonymous) return true

      if (actionName) {
        Sentry.addBreadcrumb({
          category: 'auth',
          // eslint-disable-next-line i18next/no-literal-string -- Sentry breadcrumb (not user-facing)
          message: 'Real-account command gated',
          level: 'info',
          data: { actionName },
        })
      }

      setIsModalOpen(true)
      return false
    },
    [isAnonymous],
  )

  const SignUpModalComponent = (
    <SignUpModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onSuccess={() => setIsModalOpen(false)}
      projectId={options?.projectId}
      returnPath={options?.returnPath}
    />
  )

  return {
    isGated: isAnonymous,
    guardAction,
    SignUpModalComponent,
  }
}
